import React, { Component } from 'react';
import { map } from 'lodash';
import { Select, TimePicker, Upload, message } from 'antd';
import moment from 'moment-timezone';
import * as yup from 'yup';
import Script from 'react-load-script';
import {errorHandle} from "../../../Common/errorHandle";

const { Option } = Select;

class EditUser extends Component {
  state = {
    google_service_address: '',
    // roles: [
    //   { key: 'admin', value: 'Admin' },
    //   { key: 'service_rep', value: 'Service Representative' },
    //   { key: 'franchise_owner', value: 'Franchise Owner' },
    //   { key: 'field_tech', value: 'Field Tech' },
    //   { key: 'operations_mgr', value: 'Operations Manager' },
    //   // { key: 'customer', value: 'Customer' },
    //   // { key: 'lead', value: 'Lead' },
    //   // { key: 'commercial_customer', value: 'Commercial Customer' },
    //   // { key: 'commercial_lead', value: 'Commercial Lead' },
    // ],
    skillsetList: [
      { key: 'residential_regular', value: 'Residential Regular' },
      { key: 'residential_init_clean', value: 'Residential intial Cleaning' },
      { key: 'pet_waste_station', value: 'Pet Waste Station Service' },
      { key: 'pet_waste_station_install', value: 'Pet Waste Station Installation' },
      { key: 'common_area_cleaning', value: 'Common Area Cleaning Service' },
      { key: 'trash_can_service', value: 'Trash Can Service' },
    ],
    hours_of_work: [
      {
        key: 'Sunday',
        day: 'sun',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Monday',
        day: 'mon',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Tuesday',
        day: 'tues',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Wednesday',
        day: 'wed',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Thursday',
        day: 'thurs',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Friday',
        day: 'fri',
        start_time: '',
        end_time: '',
        enable: false
      },
      {
        key: 'Saturday',
        day: 'sat',
        start_time: '',
        end_time: '',
        enable: false
      }
    ],
    group: { uuid: '', name: '' },
    user: {
      first_name: '',
      last_name: '',
      email: '',
      franchise_uuid: '',
      is_active: true,
      photo: '',
      description: ''
    },
    phone_numbers: {
      uuid: '',
      phone: '',
      type: 'mobile',
      can_send_sms: true,
      primary: true
    },
    skillset: [],
    start_location: { address: '', city: '', state: '', zip_code: '' },
    stop_location: { address: '', city: '', state: '', zip_code: '' },
    is_new_img: false,
    errors: {},
    authUserFranchiseID:'',
    authUserRole:null,
    authUserUuid:null
  }

  componentDidMount() {
    this.props.getRoles();
    let user = JSON.parse(localStorage.getItem('authUser')) || null;
    let authUserRole = user?.user?.role?.[0]
    this.setState({
      authUserFranchiseID : user?.user?.associated_field_offices?.[0]?.uuid,
      authUserRole:authUserRole,
      authUserUuid:user?.user?.uuid
    })
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    let { hours_of_work } = this.state;
    // message.destroy();

    if (Object.keys(Object.keys(props.User_details)).length > 0 && props.User_details !== this.props.User_details) {

      let { first_name, last_name, email, uuid, is_active, group, role, staff_profile, photo, description } = props.User_details
      this.setState({ loader: false })
      //set Phone numbers
      if (props.User_details.phone_numbers.length > 0) {
        map(props.User_details.phone_numbers, (item) => {
          if (item.primary) {
            this.setState({
              phone_numbers: {
                uuid: item.uuid,
                phone: item.phone,
                type: item.type,
                can_send_sms: item.can_send_sms,
                primary: item.primary
              }
            })
          }
          else {
            this.setState({
              phone_numbers: {
                uuid: item.uuid,
                phone: item.phone,
                type: item.type,
                can_send_sms: item.can_send_sms,
                primary: item.primary
              }
            })
          }

        })

      }
      else {
        this.setState({
          phone_numbers: {
            uuid: '',
            phone: '',
            type: 'mobile',
            can_send_sms: true,
            primary: true
          }
        })
      }

      // set group
      if (group) {
        this.setState({
          group
        })
      }


      let hours = [], hoursOfWork = props.User_details?.hours_of_work;
      map(hours_of_work, (stateHour) => {
        let index = hoursOfWork?.findIndex((hour) => stateHour?.day === hour?.day);

        if (index > -1) {
          hours.push({
            ...stateHour,
            start_time: hoursOfWork[index].enable ? moment(hoursOfWork?.[index]?.start_time, 'HH:mm:ss') : '',
            end_time: hoursOfWork[index].enable ? moment(hoursOfWork?.[index]?.end_time, 'HH:mm:ss') : '',
            enable: hoursOfWork[index].enable
          });
        }
        else {
          hours.push({
            ...stateHour,
            start_time: "",
            end_time: "",
            enable: false
          });
        }
      })

      this.setState({
        hours_of_work: hours
      })

      //set user and other data
      this.setState({
        user: {
          first_name,
          last_name,
          email,
          uuid,
          is_active,
          role,
          description,
          photo: photo || '',
          franchise_uuid: staff_profile?.field_office?.uuid ? staff_profile?.field_office?.uuid : '',
        },
        skillset: staff_profile && staff_profile.skillset ? staff_profile.skillset : [],
        start_location: staff_profile?.start_location ? staff_profile.start_location : { address: '', city: '', state: '', zip_code: '' },
        stop_location: staff_profile?.stop_location ? staff_profile.stop_location : { address: '', city: '', state: '', zip_code: '' },
        staff_profile,

      }, () => {
        // set location on googole place holder
        if (staff_profile && staff_profile.start_location && staff_profile.start_location) {
          if (this.refs['start_location']) {
            this.refs['start_location'].value = `${staff_profile.start_location.address}, ${staff_profile.start_location.city}, ${staff_profile.start_location.state}, ${staff_profile.start_location.zip_code}`
          }
        }
        else {
          if (this.refs['start_location']) {
            this.refs['start_location'].value = ''
          }
        }

        if (staff_profile && staff_profile.stop_location && staff_profile.stop_location) {
          if (this.refs['stop_location']) {
            this.refs['stop_location'].value = `${staff_profile.stop_location.address}, ${staff_profile.stop_location.city}, ${staff_profile.stop_location.state}, ${staff_profile.stop_location.zip_code}`

          }
        }
        else {
          if (this.refs['stop_location']) {
            this.refs['stop_location'].value = ''
          }
        }
      })
    }

    if (Object.keys(props.RoleList.data).length > 0 && props.RoleList.data !== this.props.RoleList.data) {
      if(props.is_disable_franchise){
        var filteredRoles = props.RoleList.data.results.filter(
          function(e) {
            return this.indexOf(e.name) < 0;
          },
          ['admin','service_rep','accounting_corporate']
        );
        this.setState({ roles: filteredRoles });
      }else{
        this.setState({ roles: props.RoleList.data.results });
      }
    }

    //Update User

    if (Object.keys(props.updateUser.data).length > 0 && props.updateUser.data !== this.props.updateUser.data) {
      let user = JSON.parse(localStorage.getItem('authUser')) || null;
      let temp_user = user?.user || null;

      if (props?.updateUser?.data?.uuid === temp_user?.uuid) {
        temp_user = Object.assign(temp_user, { ...props?.updateUser?.data });
        user = Object.assign(user, { user: temp_user });
        localStorage.setItem('authUser', JSON.stringify(user));
      }

      this.setState({
        group: { uuid: '', name: '' },
        user: {
          first_name: '',
          last_name: '',
          email: '',
          franchise_uuid: '',
          is_active: true,
          photo: '',
          description: ''
        },
        phone_numbers: {
          uuid: '',
          phone: '',
          type: 'mobile',
          can_send_sms: true,
          primary: true
        },
        skillset: [],
        start_stop_location: { address: '', city: '', state: '', zip_code: '' },
        is_new_img: false,

      })
      if (this.refs['address']) {
        this.refs['address'].value = ''
      }


    }

    if (Object.keys(props.updateUser.errors).length > 0 && props.updateUser.errors !== this.props.updateUser.errors) {
      // display error messsage
      this.setState({ loader: false })
      errorHandle(props?.updateUser?.errors)
    }

    this.setState({loader: false})
  }

  // get logged in user
  getLoggedInUserRole = () => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name)

    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner')
    // const is_account_corporate = logged_in_user_role?.includes('accounting_corporate')
    const is_business_dev_franchiese = logged_in_user_role?.includes('business_dev_franchiese')
    const is_operations_mgr = logged_in_user_role?.includes('operations_mgr')
    const is_field_tech = logged_in_user_role?.includes('field_tech')
    const franchise_uuid = authUser?.user?.field_offices?.map(x => x.uuid);
    return {franchise_uuid: franchise_uuid?.[0], is_disable_franchise: (is_franchise_owner || is_business_dev_franchiese || is_operations_mgr || is_field_tech)}
  }

  //Group Table Pagination
  groupHandleTableChange = (pagination, filters, sorter) => {
    let group_list_pagination = this.state.group_list_pagination;
    let ordering = ''
    group_list_pagination = Object.assign(group_list_pagination, { 'current': pagination.current });

    if (Object.keys(sorter).length > 0) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}+` : `${sorter.field}-`
    }

    this.setState({
      group_list_pagination,
      loader: true,
    })
    this.props.getUserList({ offset: (pagination.current * 10) - 10, limit: 10, ordering });
  }


  //User detil setup
  onUserDetailChange = (e) => {
    let { user } = this.state;
    user = Object.assign(user, { [e.target.name]: e.target.value });
    this.setState({
      user
    })
  }

  //Working hours change
  onWorkingHoursChange = (e, hour, index) => {
    let { hours_of_work } = this.state;

    if(e.target.checked) {
      hours_of_work[index].enable = e.target.checked;
      hours_of_work[index].start_time = moment('09:00 AM','HH:mm A');
      hours_of_work[index].end_time = moment('05:00 PM','HH:mm A')
    }
    else {
      hours_of_work[index].enable = e.target.checked;
      hours_of_work[index].start_time = '';
      hours_of_work[index].end_time = ''
    }   
    this.setState({
      hours_of_work
    })

  }

  // on Working Time Change
  onTimeChange = (e, type, hour) => {
    let { hours_of_work } = this.state;

    let index = hours_of_work.findIndex(x => x.key === hour.key);
    hours_of_work[index][type] = e;
    this.setState({
      hours_of_work
    })
  }

  //User Form Validation
  validateUser = () => {
    let { hours_of_work, user, phone_numbers, group, skillset, start_location, stop_location } = this.state;
    const UserSchema = yup.object().shape({
      user: yup.object().shape({
        first_name: yup.string().required("First name is required"),
        last_name: yup.string().required("Last name is required"),
        email: yup.string().required("Last name is required").email('Your Email is invalid.'),
        // franchise_uuid: yup.string().required("Franchise is required"),
        role: yup.string().required("Role is required"),
      }),
      phone_numbers: yup.object().shape({
        phone: yup.string().trim().matches(/^[0-9]{0}(?:[0-9]{10})?$/, 'Please enter a valid Phone Number.')
      }),
      group: yup.object().shape({
        name: yup.string().required("Group name is required"),
      }),
      // hours_of_work: yup.array().of(
      //   yup.object().shape({
      //     start_time: yup.string().when(['enable'], {
      //       is: true,
      //       then: yup.string().required('Start time is required'),
      //     }),
      //     end_time: yup.string().when(['enable'], {
      //       is: true,
      //       then: yup.string().required('End time is required'),
      //     }),
      //   })
      // ),
      skillset: yup.array().test('match', 'Skillset is required.', (skillset) => {
        if (group?.name?.toLowerCase()?.includes('field') || user?.role?.[0].includes("field")) return skillset
        return true
      }),
      start_location: yup.object().shape({
        address: yup.string(),
        city: yup.string(),
        state: yup.string(),
        zip_code: yup.string(),
      }),
      stop_location: yup.object().shape({
        address: yup.string(),
        city: yup.string(),
        state: yup.string(),
        zip_code: yup.string(),
      }),
    })


    const UserData = {
      user, phone_numbers, group, hours_of_work, skillset,
      start_location, stop_location
    }

    // check validity
    setTimeout(() => {
      UserSchema.validate(UserData, { abortEarly: false }).then(() => {
        const addressErrors = {};
        if (group?.name?.toLowerCase()?.includes('field') || user?.role?.[0].includes("field")) {
          if (!start_location.address) addressErrors['start_location.address'] = "Address is required";
          if (!start_location.city) addressErrors['start_location.city'] = "City is required";
          if (!start_location.state) addressErrors['start_location.state'] = "State is required";
          if (!start_location.zip_code) addressErrors['start_location.zip_code'] = "Zipcode is required";

          if (!stop_location.address) addressErrors['stop_location.address'] = "Address is required";
          if (!stop_location.city) addressErrors['stop_location.city'] = "City is required";
          if (!stop_location.state) addressErrors['stop_location.state'] = "State is required";
          if (!stop_location.zip_code) addressErrors['stop_location.zip_code'] = "Zipcode is required";
        }

        let hours = [];
        if (user?.role?.includes('field_tech')) {
          map(hours_of_work, x => {
            if (x.enable) {
              if (x.start_time && x.end_time) hours.push(x)
            }
          })
        }

        if (user?.role?.includes('field_tech') && hours?.length === 0) {
          this.setState({ errors: { hours_of_work: 'Hours of work is required' } })
        } else if (Object.keys(addressErrors).length > 0) {
          this.setState({ errors: addressErrors })
        } else {
          this.setState({ errors: {} })
          this.updateUSer();
        }
      }).catch((err) => {
        let err_data = {};
        map(err.inner, (item) => { err_data[item.path] = item.message })
        this.setState({ errors: err_data })
      });
    }, 100);
  }

  // user photo selection
  userPhotoUpload = (info) => {
    let { user } = this.state;

    var self = this;
    const reader = new FileReader();
    reader.onloadend = function () {
      user = Object.assign(user, { 'photo': reader.result });
      self.setState({ user, is_new_img: true });
    }
    reader.readAsDataURL(info.file);


  }


  // convert images to base64
  getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  // Render Skill Set
  renderSkillSet = () => {
    let { skillsetList, skillset } = this.state;
    return map(skillsetList, (item, i) => {
      return (
        <div className="fitem-check" key={i}>
          <input
            type="checkbox"
            className="fitem-ck-input"
            id={`skill${i}`}
            onChange={(e) => { this.onSkillSetChange(e, item); }}
            checked={skillset.includes(item.key)}
            name="checkboxs" />
          <label htmlFor={`skill${i}`} className="fitem-ck-txt">{item.value}</label>
        </div>
      )
    })
  }

  //Set skill set value
  onSkillSetChange = (e, item) => {
    let { skillset } = this.state;
    if (e.target.checked) {
      skillset.push(item.key);
    }
    else {
      const index = skillset.indexOf(item.key);
      if (index > -1) {
        skillset.splice(index, 1);
      }
    }
    this.setState({ skillset })
  }

  // Google Map Place API
  handleScriptLoad = () => {

    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: 'us' } };

    //////////////////////Start Location////////////////////////
    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const startLocationAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_start_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    startLocationAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    startLocationAutoComplete.addListener('place_changed', this.startLocationChange);

    this.setState({
      startAutocomplete: startLocationAutoComplete,
    })



    //////////////////////Stop Location////////////////////////
    const stopLocationAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById('google_stop_address'),
      options,
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    stopLocationAutoComplete.setFields(['address_components', 'formatted_address']);

    // Fire Event when a suggested name is selected
    stopLocationAutoComplete.addListener('place_changed', this.stopLocationChange);

    this.setState({
      stopAutocomplete: stopLocationAutoComplete,
    })


  };


  //Start Address change
  startLocationChange = () => {
    const { startAutocomplete } = this.state;
    const addressObject = startAutocomplete.getPlace();
    let obj = {};


    map(addressObject?.address_components, (item) => {

      if (item?.types?.includes('route') || item?.types?.includes('administrative_area_level_2')) {
        obj = Object.assign(obj, { 'address': item.short_name })
      }
      if (item?.types?.includes('route')) {
        obj = Object.assign(obj, { 'route': item.short_name })
      }
      if (item?.types?.includes('street_number')) {
        obj = Object.assign(obj, { 'street_number': item.short_name })
      }
      if (item?.types?.includes('administrative_area_level_1')) {
        obj = Object.assign(obj, { 'state': item.short_name })
      }
      if (item?.types?.includes('locality')) {
        obj = Object.assign(obj, { 'city': item.long_name })
      }
      if (item?.types?.includes('postal_code')) {
        obj = Object.assign(obj, { 'zip_code': item.short_name })
      }
    });
    this.setState({ start_location: obj }, () => {
      if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
        message.error('Please enter valid start location');
      }
      // this.validate()
    });
  }

  //Stop Address change
  stopLocationChange = () => {
    const { stopAutocomplete } = this.state;
    const addressObject = stopAutocomplete.getPlace();
    let obj = {};


    map(addressObject?.address_components, (item) => {

      if (item?.types?.includes('route') || item?.types?.includes('administrative_area_level_2')) {
        obj = Object.assign(obj, { 'address': item.short_name })
      }
      if (item?.types?.includes('route')) {
        obj = Object.assign(obj, { 'route': item.short_name })
      }
      if (item?.types?.includes('street_number')) {
        obj = Object.assign(obj, { 'street_number': item.short_name })
      }
      if (item?.types?.includes('administrative_area_level_1')) {
        obj = Object.assign(obj, { 'state': item.short_name })
      }
      if (item?.types?.includes('locality')) {
        obj = Object.assign(obj, { 'city': item.long_name })
      }
      if (item?.types?.includes('postal_code')) {
        obj = Object.assign(obj, { 'zip_code': item.short_name })
      }
    });
    this.setState({ stop_location: obj }, () => {
      if (!obj?.address || !obj?.state || !obj.city || !obj.zip_code) {
        message.error('Please enter valid start location');
      }
      // this.validate()
    });
  }


  //Add New User
  updateUSer = () => {
    let { user, hours_of_work, group, phone_numbers, skillset, start_location, stop_location, is_new_img } = this.state;
    let temp_hours_of_work = []

    // set hours of work
    map(hours_of_work, (item, i) => {
      if (hours_of_work[i]['start_time'] && hours_of_work[i]['end_time']) {
        temp_hours_of_work.push({
          key: hours_of_work[i]['key'],
          day: hours_of_work[i]['day'],
          start_time: moment(hours_of_work[i]['start_time']).format('HH:mm:ss A'),
          end_time: moment(hours_of_work[i]['end_time']).format('HH:mm:ss A'),
          enable: true
        })
      }
      else {
        temp_hours_of_work.push({
          key: hours_of_work[i]['key'],
          day: hours_of_work[i]['day'],
          start_time: null,
          end_time: null,
          enable: false
        })
      }


    })

    if (!is_new_img) {
      delete user.photo
    }
    let staff_profile = { skillset: skillset?.length > 0 ? skillset : null,
      start_location: (start_location?.street_number && start_location?.route) ? {...start_location, address: `${start_location?.street_number} ${start_location?.route}`} : start_location,
      stop_location: (stop_location?.street_number && stop_location?.route) ? {...stop_location, address: `${stop_location?.street_number} ${stop_location?.route}`} : stop_location }

    if (staff_profile.start_location.uuid) {
      staff_profile.start_location = {}
    }
    if (staff_profile.stop_location.uuid) {
      staff_profile.stop_location = {}
    }

    // stop_location.uuid ? stop_location = '' : stop_location;


    let temp_phone_numbers = [];
    let data;
    if(phone_numbers.phone){
      temp_phone_numbers.push(phone_numbers);
    }

    map(temp_phone_numbers, x => {
      if (!x.uuid) delete x?.uuid
    })

    data = {
      ...user,
      hours_of_work: temp_hours_of_work,
      phone_numbers: temp_phone_numbers,
      group,
      staff_profile
    }
    this.setState({
      loader: true
    })

    if (data?.franchise_uuid === '') {
      const {franchise_uuid, is_disable_franchise} = this.getLoggedInUserRole();
      if (is_disable_franchise) Object.assign(data, {franchise_uuid})
      else delete data.franchise_uuid
    }

    this.props.updateEditedUSer(data, user.uuid)

  }

  // render specific setting
  renderSpecificSetting = () => {
    const { errors } = this.state;
    // const { specificSetting, errors, group } = this.state;
    // const { groupList } = this.props
    // const grp = groupList?.filter((item) => item.uuid === group?.uuid);
    // let startAddress = '', stopAddress = '';
    // if (!_.isEmpty(start_location)) {
    //   startAddress = start_location.address ? `${start_location?.address}` : '';
    //   startAddress += start_location?.city ? `, ${start_location?.city}` : '';
    //   startAddress += start_location?.state ? `, ${start_location?.state}` : '';
    //   startAddress += start_location?.zip_code ? `, ${start_location?.zip_code}` : '';
    // }
    // if (!_.isEmpty(stop_location)) {
    //   stopAddress = stop_location?.address ? `${stop_location?.address}` : '';
    //   stopAddress += stop_location?.city ? `, ${stop_location?.city}` : '';
    //   stopAddress += stop_location?.state ? `, ${stop_location?.state}` : '';
    //   stopAddress += stop_location?.zip_code ? `, ${stop_location?.zip_code}` : '';
    // }

    return (
      <div className="specific-fitem">
        <Script
          url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
          onLoad={() => window.requestAnimationFrame(this.handleScriptLoad)}

        />
        <h6>Field Tech Specific Settings</h6>
        <div className="fitem">
          <label htmlFor="">Start Location</label>
          <input
            autoComplete="off"
            type="text"
            ref="start_location"
            onChange={(e) => {
              if (!e.target.value) {
                this.setState({
                  start_location: { address: '', state: '', city: '', zip_code: '' }
                })
              }
            }}
            className={'form-control'}
            name="google_start_address"
            id="google_start_address"
            placeholder={'Enter start location'}
          />
          {(errors['start_location.address'] || errors['start_location.city'] || errors['start_location.state'] || errors['start_location.zip_code']) ?
            <label className="new_err_msg"><i className="las la-info-circle"/>{'Enter valid start location'}</label> : ''}
        </div>

        <div className="fitem">
          <label htmlFor="">Stop Location</label>
          <input
            autoComplete="off"
            type="text"
            ref="stop_location"
            onChange={(e) => {
              if (!e.target.value) {
                this.setState({
                  stop_location: { address: '', state: '', city: '', zip_code: '' }
                })
              }
            }}
            className={'form-control'}
            name="google_stop_address"
            id="google_stop_address"
            placeholder={'Enter stop location'}
          />
          {(errors['stop_location.address'] || errors['stop_location.city'] || errors['stop_location.state'] || errors['stop_location.zip_code']) ?
            <label className="new_err_msg"><i className="las la-info-circle"/>{'Enter valid stop location'}</label> : ''}
        </div>


        <div className="fitem inline-check-list gcheck mt-20">
          {/* Render Skill */}
          {this.renderSkillSet()}
          {errors['skillset'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['skillset']}</label> : ''}
        </div>

      </div>
    )
  };


  render() {
    let { loader, user, phone_numbers, errors, hours_of_work, group,roles } = this.state;
    let { franchiseList, groupList, roleList } = this.props;
    const {is_disable_franchise} = this.getLoggedInUserRole();
    const grp = groupList?.filter((item) => item.uuid === group?.uuid);
    return (
      <React.Fragment>

        <div className="add_user_wrapper rdrawer">
          <div className="card-row">
            <div className="card-half left-sec">
              <h4>Edit User</h4>
              <div className="form-group">
                <div className="fitem">
                  <label htmlFor="">First Name</label>
                  <input
                    type="text"
                    placeholder="First Name"
                    name="first_name"
                    value={user.first_name}
                    onChange={(e) => { this.onUserDetailChange(e) }} />
                  {errors['user.first_name'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['user.first_name']}</label> : ''}
                </div>

                <div className="fitem">
                  <label htmlFor="">Last Name</label>
                  <input
                    type="text"
                    placeholder="Last Name"
                    name="last_name"
                    value={user.last_name}
                    onChange={(e) => { this.onUserDetailChange(e) }} />
                  {errors['user.last_name'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['user.last_name']}</label> : ''}
                </div>

                <div className="fitem">
                  <label htmlFor="">Phone number</label>
                  <div className={phone_numbers.phone ? 'fix_isd_code' : ''}>
                    {phone_numbers.phone ? <span>+1</span> : ''}
                    <input
                      style={{marginLeft: phone_numbers?.phone ? "10px" : "0px"}}
                      type="text"
                      placeholder="Phone number"
                      name="phone_numbers"
                      value={phone_numbers?.phone}
                      inputMode="numeric"
                      max='10'
                      maxLength='10'
                      onPaste={(event) => {
                        if (event.clipboardData.getData('Text').match(/[^\d]/)) {
                          event.preventDefault();
                        }
                      }}
                      onKeyPress={(e) => {
                        const pattern = /[0-9]/;
                        const inputChar = String.fromCharCode(e.charCode);
                        if (!pattern.test(inputChar)
                        ) {
                          // invalid character, prevent input
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        let { phone_numbers } = this.state;
                        phone_numbers = Object.assign(phone_numbers, { 'phone': e.target.value });
                        this.setState({
                          phone_numbers
                        })
                      }} />
                    {errors['phone_numbers.phone'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['phone_numbers.phone']}</label> : ''}
                  </div>


                </div>

                <div className="fitem">
                  <label htmlFor="">Email</label>
                  <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={user.email}
                    onChange={(e) => { this.onUserDetailChange(e) }} />
                  {errors['user.email'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['user.email']}</label> : ''}
                </div>

                <div className="fitem">
                  <label htmlFor="">Franchise</label>
                  <Select
                    value={user.franchise_uuid || undefined}
                    style={{ 'width': '100%' }}
                    placeholder="Franchise"
                    onChange={(e) => {
                      let { user } = this.state;
                      user = Object.assign(user, { 'franchise_uuid': e });
                      this.setState({ user }, () => {
                        this.setState({loader: true, group: { 'uuid': '', 'name': '' }})
                        if(user.role?.includes('service_rep') || !this.state.user?.franchise_uuid){
                          this.props.getGroupList({ 'offset': 0, 'limit': 15, 'is_public': true });
                        } else {
                          this.props.getGroupList({ 'offset': 0, 'limit': 15, field_office__uuid: this.state.user?.franchise_uuid || '' });
                        }
                      })
                    }}
                    disabled={ this.state.authUserRole==='admin'  ? false : true}
                  >
                    {map(franchiseList, (item, i) => {
                      return (
                        <Option key={i} value={item.uuid}>{item.name}</Option>
                      )
                    })}

                  </Select>
                </div>

                <div className="fitem">
                  <label htmlFor="">Group</label>
                  <Select

                    style={{ 'width': '100%' }}
                    placeholder="Please Select"
                    value={group.name || undefined}
                    // eslint-disable-next-line
                    onChange={({ }, e) => {
                      this.setState({
                        group: { 'uuid': e.value, 'name': e.children }
                      })
                    }}
                  >
                    {groupList.filter(item => item.status === 'active').map((item, i) => {
                      return (
                        <Option key={i} value={item.uuid} >{item.name}</Option>
                      )
                    })}
                  </Select>
                  {errors['group.name'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['group.name']}</label> : ''}
                </div>

                <div className="fitem">
                  <label htmlFor="">Roles</label>
                  <Select
                    value={user.role || undefined}
                    style={{ 'width': '100%' }}
                    placeholder="Roles"
                    onChange={(e) => {
                      let { user } = this.state;
                      let role = [];
                      role.push(e)
                      user = Object.assign(user, { role });
                      this.setState({ user });
                      if(user.role?.includes('service_rep') || !this.state.user?.franchise_uuid){
                        this.props.getGroupList({ 'offset': 0, 'limit': 15, 'is_public': true });
                        this.setState({loader: true, group: { 'uuid': '', 'name': '' }});
                      } else {
                        this.props.getGroupList({ 'offset': 0, 'limit': 15, field_office__uuid: this.state.user?.franchise_uuid || '' });
                      }
                    }}
                    disabled={this.state.authUserUuid===user.uuid ||  this.state.authUserRole==='field_tech' || this.state.authUserRole==='service_rep'? true : false}
                  >

                    {map(roles, (item, i) => {
                      return (
                        <Option key={i} value={item.name}>{item.display_name}</Option>
                      )
                    })}
                  </Select>
                  {errors['user.role'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['user.role']}</label> : ''}
                </div>

                {(grp?.[0]?.name?.toLowerCase()?.includes('field') || user?.role?.[0].includes("field")) && this.renderSpecificSetting()}
                {/* <div className="specific-fitem">
                  <Script
                    url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
                    onLoad={this.handleScriptLoad}

                  />
                  <h6>Field Tech Specific Settings</h6>
                  <div className="fitem">
                    <label htmlFor="">Start Location</label>
                    <input
                      autoComplete="off"
                      type="text"
                      ref="start_location"
                      onChange={() => { this.startLocationChange() }}
                      className={'form-control'}
                      name="google_start_address"
                      id="google_start_address"
                    />
                    {errors['start_location.address'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['start_location.address']}</label> : ''}
                  </div>

                  <div className="fitem">
                    <label htmlFor="">Stop Location</label>
                    <input
                      autoComplete="off"
                      type="text"
                      ref="stop_location"
                      onChange={() => { this.stopLocationChange() }}
                      className={'form-control'}
                      name="google_stop_address"
                      id="google_stop_address"
                    />
                    {errors['stop_location.address'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['stop_location.address']}</label> : ''}
                  </div>


                  <div className="fitem inline-check-list gcheck mt-20">
                    Render Skill
                    {this.renderSkillSet()}
                    {errors['skillset'] ? <label className="new_err_msg"><i className="las la-info-circle"></i>{errors['skillset']}</label> : ''}
                  </div>

                </div> */}
              </div>
              <div className="hours-work-wrap mt-20">
                <h5>Hours of work</h5>
                {map(hours_of_work, (item, i) => {
                  return (
                    <div className="fitem inline-check-list gcheck" key={i}>
                      <div className="fitem-check flex mb-10 ai-center">
                        <div className="hours-week">
                          <input className="fitem-ck-input" type="checkbox"
                            id={i}
                            checked={hours_of_work[i].enable}
                            onChange={(e) => { this.onWorkingHoursChange(e, hours_of_work[i], i) }}
                          />
                          <label htmlFor={i} className="fitem-ck-txt mb-0">{item.key}</label>
                        </div>
                        <div className="flex">
                          <div className="fitem">
                            <TimePicker
                              format="hh:mm A"
                              minuteStep={15}
                              placeholder="From"
                              ref={`start_time${i}`}
                              disabled={!hours_of_work[i]['enable']}
                              value={hours_of_work[i].start_time === "" ? null : hours_of_work[i].start_time}
                              suffixIcon={<i className="las la-angle-down"></i>}
                              allowClear={false}
                              onChange={(e) => { this.onTimeChange(e, 'start_time', hours_of_work[i]) }}
                            />
                          </div>
                          <div className="fitem">
                            <TimePicker
                              placeholder="To"
                              format="hh:mm A"
                              minuteStep={15}
                              allowClear={false}
                              suffixIcon={<i className="las la-angle-down"></i>}
                              disabled={!hours_of_work[i]['enable']}
                              value={hours_of_work[i].end_time === "" ? null : hours_of_work[i].end_time}
                              onChange={(e) => { this.onTimeChange(e, 'end_time', hours_of_work[i]) }}
                            />
                          </div>
                        </div>
                      </div>

                      <div>

                      </div>
                    </div>
                  )
                })}
                {errors?.['hours_of_work'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['hours_of_work']}</label> : ''}
              </div>

              <div className="fitem">
                <label htmlFor="">Status</label>
                <Select
                  value={user.is_active}
                  defaultValue="true"
                  style={{ 'width': '100%' }}
                  placeholder="Status"
                  onChange={(e) => {
                    let { user } = this.state;
                    user = Object.assign(user, { 'is_active': e });
                    this.setState({ user })
                  }}
                >
                  <Option value={true}>Active</Option>
                  <Option value={false}>InActive</Option>
                </Select>
              </div>
            </div>
            <div className="img_upload right-sec card-half">
              <h4>User’s Bio</h4>
              <blockquote className="horiz">
                <b>The customer will see this information about you!</b>
                <p> As a field tech, customers will see who has serviced their property; and as a customer care rep, when you reply to tickets, customers will know who they are talking to!</p>
              </blockquote>

              <div className="file_upload_section flex ai-center flex-start">
                {
                  user.photo ?
                    <div className="uploded_img">

                      <img src={user.photo} alt="" className="user_img" />
                    </div>
                    :
                    <Upload
                      name="avatar"
                      listType="picture-card"
                      className="avatar-uploader"
                      showUploadList={false}
                      beforeUpload={() => false}
                      onChange={(e) => { this.userPhotoUpload(e) }}>

                      <div className="upload_text">
                        <i className="las la-plus-circle"></i>
                        <p>Upload Photo Optional</p>
                      </div>
                    </Upload>
                }

                {user.photo ?
                  <div className="action-btn">
                    <Upload
                      name="avatar"

                      showUploadList={false}
                      beforeUpload={() => false}
                      onChange={(e) => { this.userPhotoUpload(e) }}
                    >
                      <button className="btn btn-bdr btn-xs mr-2" type="button">Replace</button>
                    </Upload>

                    <button type="button"
                      className="btn btn-bdr btn-danger btn-xs"
                      onClick={() => {
                        let { user } = this.state
                        user = Object.assign(user, { 'photo': '' });
                        this.setState({
                          user,
                          is_new_img: true
                        })
                      }}>Remove</button>
                  </div> : ''}
              </div>

              <div className="fitem">
                <label>a little about me</label>
                <textarea
                  value={user.description || ''}
                  name="description"
                  onChange={(e) => { this.onUserDetailChange(e) }}></textarea>
              </div>
            </div>
          </div>

          <div className="footer" style={{'width':'411px'}}>
            <button className="btn btn-primary" onClick={() => {
              this.setState({ errors: {} }, () => this.props.userEditDrawerToggle(false))
            }}>Cancel</button>
            <button
              className=" btn btn-warning"
              // className={!is_add_user_Active ? 'btn disabled' : 'btn btn-warning'}
              // disabled={!is_add_user_Active}
              onClick={() => { this.validateUser() }}

            >Update User</button>
          </div>
        </div>
        {
          loader ?
            <div className='loader_wrapper'>
              < div className='loader07' ></div >
            </div >
            : ''
        }
      </React.Fragment>
    );
  }
}

export default EditUser;